"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DanceAiPreviewButtonToggleState = exports.DanceAiModalMode = exports.EffectsQuality = exports.FieldKey = exports.DanceAiModalOutputType = void 0;
var DanceAiModalOutputType;
(function (DanceAiModalOutputType) {
    DanceAiModalOutputType["AI_BLOCK"] = "ai_block";
    DanceAiModalOutputType["GENERATED_BLOCKS"] = "generated_blocks";
    DanceAiModalOutputType["BOTH"] = "both";
})(DanceAiModalOutputType || (exports.DanceAiModalOutputType = DanceAiModalOutputType = {}));
var FieldKey;
(function (FieldKey) {
    FieldKey["BACKGROUND_EFFECT"] = "backgroundEffect";
    FieldKey["FOREGROUND_EFFECT"] = "foregroundEffect";
    FieldKey["BACKGROUND_PALETTE"] = "backgroundColor";
})(FieldKey || (exports.FieldKey = FieldKey = {}));
var EffectsQuality;
(function (EffectsQuality) {
    EffectsQuality["GOOD"] = "good";
    EffectsQuality["BAD"] = "bad";
})(EffectsQuality || (exports.EffectsQuality = EffectsQuality = {}));
var DanceAiModalMode;
(function (DanceAiModalMode) {
    DanceAiModalMode["INITIAL"] = "initial";
    DanceAiModalMode["SELECT_INPUTS"] = "selectInputs";
    DanceAiModalMode["GENERATING"] = "generating";
    DanceAiModalMode["GENERATED"] = "generated";
    DanceAiModalMode["RESULTS"] = "results";
    DanceAiModalMode["EXPLANATION"] = "explanation";
})(DanceAiModalMode || (exports.DanceAiModalMode = DanceAiModalMode = {}));
var DanceAiPreviewButtonToggleState;
(function (DanceAiPreviewButtonToggleState) {
    DanceAiPreviewButtonToggleState["EFFECT"] = "effect";
    DanceAiPreviewButtonToggleState["CODE"] = "code";
})(DanceAiPreviewButtonToggleState || (exports.DanceAiPreviewButtonToggleState = DanceAiPreviewButtonToggleState = {}));
